<template>
    <div style="width: 100%;">
      <ul>
        <li><a href="javascript:void(0)" @click="goBack"><img src="../../static/images/fixed_icon1.png"><p>返回</p></a></li>
        <li><a href="javascript:void(0)"  @click="urlTo('personal_cardMaking',{index:'true'})"><img src="../../static/images/fixed_icon2.png"><p>个人中心</p></a></li>
<!--        <li><a href="javascript:void(0)" @click="urlTo('applyList')"><img src="../../static/images/fixed_icon3.png"><p>办件进度</p></a></li>-->
        <!--<li>-->
          <!--<el-tooltip content="暂未开放" placement="left">-->
          <!--<a href="javascript:void(0)"><img src="../../static/images/fixed_icon4.png"  ><p>我要预约</p></a>-->
          <!--</el-tooltip>-->
          <!--&lt;!&ndash;<a href="javascript:void(0)" @click="urlTo('/arrange')"><img src="../../static/images/fixed_icon4.png"  ><p>我要预约</p></a>&ndash;&gt;-->
        <!--</li>-->
<!--        <li><a href="javascript:void(0)" @click="urlTo('/suggest_zx',{title:'咨询',type:4,source:1})"><img src="../../static/images/fixed_icon5.png" ><p>我要咨询</p></a></li>-->
<!--        <li><a href="javascript:void(0)" @click="urlTo('/suggest',{title:'建议',type:2,source:1})"><img src="../../static/images/fixed_icon7.png"  ><p>我要建议</p></a></li>-->

<!--        <li><a href="javascript:void(0)" @click="urlTo('/suggest_ts',{title:'投诉',type:1,source:1})" ><img src="../../static/images/fixed_icon6.png"><p>我要投诉</p></a></li>-->
<!--         <li><a href="javascript:void(0)" @click="dialogFormVisibleShow"><img src="../../static/images/kfrx.png"  ><p>服务热线</p></a></li>-->
        <li><a href="https://mzt.qinghai.gov.cn/guestbook/" target="_blank"><img src="../../static/images/fixed_icon5.png"><p>咨询投诉</p></a></li>
        <li><a href="javascript:void(0)" @click="showPublicImg"><img src="../../static/images/fixed_icon11.png"><p>青海民政公众号</p></a></li>
        <li><a href="javascript:void(0)" @click="showPublicApkImg"><img src="../../static/images/PublicApkDownLoadPic.png"><p>青民通办APP</p></a></li>
        <li><a href="https://mzt.qinghai.gov.cn/ygcs_home" target="_blank"><img src="../../static/images/cs_logo.png"><p>阳光慈善</p></a></li>
      </ul>
      <el-dialog
        :visible.sync="showFlag" :lockScroll="false"
        width="500px"
        class="my-info-dialog"
      >
        <div style="width: 100%;text-align: center">
        <h2>青海民政公众号</h2>
       <img src="../../static/images/public/public_ewm2.jpg" style="width:300px;height: 300px;"/>
        <div style="width: 100%;line-height: 30px;">*请使用手机微信扫码关注</div>
        </div>
      </el-dialog>
      <el-dialog
        class="my-info-dialog"
        :visible.sync="apkShowFlag" :lockScroll="false"
        width="500px" >
        <div style="width: 100%;text-align: center">
          <h2 style="">青民通办app</h2>
        <img src="../../static/images/PublicApkDownLoadPic.png" style="width:300px;height: 300px;padding-top: 20px"/>
        <div style="width: 100%;line-height: 30px;">*请使用安卓手机扫码下载</div>
        </div>
      </el-dialog>
      <!-- Form -->
      <el-dialog   :visible.sync="dialogFormVisible">
        <h2 style="padding-bottom: 20px">服务热线</h2>
        <div  style="padding-left: 40px;padding-right: 20px;text-align: left">
          <div style="max-width: 700px">
            <span style="color: #f56c6c">温馨提示：</span>
            <span style="color: black;line-height: 30px">

              <br/>
                1、如您在使用“青民通办”平台过程中有任何疑问或问题，请拨打客服热线电话寻求帮助;<br />
          2、客服热线服务时间：工作日9:00-18:00。
          </span>
          </div>

          <div style="padding-top: 30px" >
            <el-row>
              <el-col :span="9"><div class="grid-content bg-purple" style="text-align: right"><img src="../../static/images/photoImg.png"></div></el-col>
              <el-col :span="15"><div class="grid-content bg-purple-light"> <h1 style="padding-top: 20px;padding-left: 15px"> </h1></div></el-col>
            </el-row>
          </div>
       <!--   <div style="padding-top: 20px">
            <h2>留言反馈</h2>
          </div>
          <div>
            <el-form  label-width="100px" class="demo-ruleForm">
              <el-row>
                <el-col :span="1"><div class="grid-content bg-purple">  <img style="padding-top: 33px;padding-left: 20px"  src="../../static/images/required.png" ></div></el-col>
                <el-col :span="23"><div class="grid-content bg-purple-light">
                  <el-form-item  style="padding-top: 20px" label="反馈标题：" >
                    <el-input   maxlength="249"  style="width: 90%;" v-model="s_title" placeholder="请输入您的看法和建议"></el-input>
                  </el-form-item></div></el-col>
              </el-row>
              <el-row>
                <el-col :span="1"><div class="grid-content bg-purple">  <img style="padding-top: 12px;padding-left: 20px"  src="../../static/images/required.png" ></div></el-col>
                <el-col :span="23"><div class="grid-content bg-purple-light">
                  <div style="padding-bottom: 30px;">
                    <el-form-item  label="反馈内容：" >
                      <el-input
                        style="width: 90%;padding-top: 10px"
                        type="textarea"
                        maxlength="249"
                        :autosize="{ minRows: 5, maxRows: 10}"
                        placeholder="请输入您的看法和建议"
                        show-word-limit
                        v-model="s_reamrk">
                      </el-input>
                    </el-form-item>
                  </div></div></el-col>
              </el-row>

            </el-form>
          </div>
          <div >
            <h2>图片（提供问题截图）</h2>
          </div>
          <el-row style="padding-top: 20px;">
            <el-col :span="5"><div class="grid-content bg-purple">
              &nbsp;
            </div></el-col>
            <el-col :span="6"><div class="grid-content bg-purple">
              <imgUploaderOne  :limit="1" :canEdit="canEditBoolean" v-model="file1"/>
            </div></el-col>
            <el-col :span="6"><div class="grid-content bg-purple-light">
              <imgUploaderOne :limit="1" :canEdit="canEditBoolean" v-model="file2"/>
            </div></el-col>
            <el-col :span="6"><div class="grid-content bg-purple">
              <imgUploaderOne :limit="1" :canEdit="canEditBoolean" v-model="file3"/>
            </div></el-col>
          </el-row>
          <div style="padding-top: 20px;text-align: center">
            <el-button :disabled="submitDisabled" @click="submit" style="width: 90%;height: 60px" type="primary">提 交</el-button>
          </div>-->
        </div>
      </el-dialog>
      <div style="height:16px;"></div>
    </div>
</template>

<script>
  import imgUploaderOne from "../components/ImgUploaderOne";
  export default {
    watch: {
      'file_ids'(n,o){
        if (n.length==3){
          this.$message({
            message: '已达到文件数量上限',
            type: 'warning'
          });
        }
      },
    },
    name: "fixedDiv",
    props:{
    },
    components:{
      imgUploaderOne
    },
    data(){
      return{
        ruleForm:{
          s_title:'',
          s_reamrk:'',
          people_tel:'',
          fileList:[],
          file_ids:[],
        },

        file_ids:[],
        s_title:'',
        s_reamrk:'',
        people_name:'',
        people_tel:'',
        file3:[],
        file2:[],
        file1:[],
        fileList:[],
        showFlag:false,
        canEditBoolean:true,
        submitDisabled:false,
        apkShowFlag:false,
        dialogFormVisible:false,
        photo:400-123-1234,

        rules: {
          s_title: [
            { required: true, message: '请输入反馈标题', trigger: 'change' }
          ],
          s_reamrk: [
            { required: true, message: '请输入反馈内容', trigger: 'change' }
          ],
        },
      }
    },
    created(){
    },

    methods:{
      goBack(){
        this.$router.back();
      },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    },
      getClass(t){
        if(t==this.pageType){
          return "on";
        }else{
          return "";
        }
      },
      submit(){
        if (this.s_title==''){
          const h = this.$createElement;

          this.$notify({
            message: h('i', { style: 'color: teal'}, '请输入反馈标题!')
          });
          return false;
        }
        if (this.s_reamrk==''){
          const h = this.$createElement;

          this.$notify({
            message: h('i', { style: 'color: teal'}, '请输入反馈内容!')
          });
          return false;
        }
        if (this.file1!='' && this.file1.length!=0){
          this.fileList.push(this.file1[0]);
        } if (this.file2!='' && this.file2.length!=0){
          this.fileList.push(this.file2[0]);
        } if (this.file3!='' && this.file3.length!=0){
          this.fileList.push(this.file3[0]);
        }

        if (this.fileList.length!=0){
          var fileListTepm= this.fileList.toLocaleString()
        }else {
          var fileListTepm= ""
        }
        this.submitDisabled=true;
        const options={
          people_name:this.people_name,
          people_tel:this.people_tel,
          s_title:this.s_title,
          s_reamrk:this.s_reamrk,
          file_ids:fileListTepm,
        }
        this.$https.post("/api/pu/savePuSuggest.do",options,(responsesss)=>{

          if (responsesss.data.code==200  ){
            this.dialogFormVisible=false;
            this.$alert('您的意见反馈已收到，感谢您的支持！' , {
              confirmButtonText: '确定',
              callback: action => {
                window.location.reload()
              }
            });
          }else {
            this.submitDisabled=false;

            /*   this.s_reamrk='';
               this.s_title='';*/
            this.file1=[];
            this.file2=[];
            this.file3=[];
            this.fileList=[];
            this.$alert('提交失败，请稍后重试' , {
              confirmButtonText: '确定',
              callback: action => {
                this.urlTo("home")
              }
            });
          }
        });
      },
      dialogFormVisibleShow(){
        this.dialogFormVisible=true;
        var t=this;
        this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            t.people_name=response.data.data.userName;
            if(t.people_name==''||t.people_name==null){
              t.people_name=response.data.data.userNikeName;
            }
            t.people_tel=response.data.data.userTel;
          }
        })
      },
      showPublicImg(){
        this.showFlag=true;
      },
      showPublicApkImg(){
        this.apkShowFlag=true;
      }
    }
  }
</script>

<style>
  .my-info-dialog .el-dialog__body {
    padding-top: 0px;

  }

</style>



// WEBPACK FOOTER //
// src/components/FixedDiv.vue